export default __webpack_public_path__ + "static/media/the-weeping-city.b057f49a.png";